import React from "react";

export const CallAnalysisPanel = ({ phonemes, livePhoneme, wave }) => (
  <div
    className="rounded-2xl p-6"
    style={{ background: "#252030", border: "1px solid rgba(250,249,251,0.08)" }}
  >
    <div className="flex items-center gap-2 mb-4">
      <span className="wk-live-dot" />
      <span
        className="text-[11px] uppercase tracking-[0.14em] font-medium"
        style={{ color: "#7228C8" }}
      >
        IA fonética activa
      </span>
    </div>
    <div className="text-[13px] mb-6" style={{ color: "rgba(250,249,251,0.6)" }}>
      Analizando tu pronunciación sin interrumpir la llamada. Recibirás el diagnóstico al colgar.
    </div>
    <div
      className="rounded-xl p-5 mb-5"
      style={{ background: "rgba(114,40,200,0.15)", border: "1px solid rgba(114,40,200,0.3)" }}
    >
      <div
        className="text-[11px] uppercase tracking-[0.14em] mb-2"
        style={{ color: "rgba(250,249,251,0.6)" }}
      >
        Fonema detectado ahora
      </div>
      <div className="flex items-baseline gap-3">
        <div className="font-mono-num text-[40px] font-bold tracking-hero leading-none">
          {livePhoneme.label}
        </div>
        <div
          className="font-mono-num text-[18px] font-semibold tabular-nums"
          style={{ color: livePhoneme.score >= 80 ? "#7228C8" : "rgba(250,249,251,0.7)" }}
        >
          {livePhoneme.score}%
        </div>
      </div>
    </div>
    <div className="flex items-end gap-0.5 h-20 mb-5">
      {wave.slice(-40).map((bar, index) => (
        <div
          key={bar.id}
          style={{
            flex: 1,
            height: `${bar.height}%`,
            background: "#7228C8",
            opacity: 0.3 + (index / 40) * 0.7,
            borderRadius: 2,
          }}
        />
      ))}
    </div>
    <div className="text-[11px]" style={{ color: "rgba(250,249,251,0.5)" }}>
      Micro puntuación · se actualiza cada segundo
    </div>
    <div className="mt-3 flex flex-wrap gap-2">
      {phonemes.map((phoneme) => (
        <span
          key={phoneme}
          className="text-[12px] px-2 py-1 rounded font-mono-num"
          style={{ background: "rgba(250,249,251,0.06)", color: "rgba(250,249,251,0.7)" }}
        >
          {phoneme} {70 + Math.floor(Math.random() * 25)}%
        </span>
      ))}
    </div>
  </div>
);